export class PlumbingTool {
    public name: string;
    public frame: string;
    public usingTool: boolean;
    public object?: Phaser.GameObjects.Sprite;
    public width: number;
    public height: number;

    public static TOOLS: PlumbingTool[] = [
        {
            name: "plunger",
            frame: "plunger",
            usingTool: false,
            width: 64,
            height: 64,
        },
        {
            name: "wrench",
            frame: "wrench",
            usingTool: false,
            width: 32,
            height: 64,
        },
        {
            name: "blowtorch",
            frame: "blowtorch",
            usingTool: false,
            width: 64,
            height: 64,
        },
        {
            name: "tape",
            frame: "tape",
            usingTool: false,
            width: 32,
            height: 32,
        }
    ];
}



// WEBPACK FOOTER //
// ./src/games/PlumbingGame/objects/PlumbingTool.ts